import { useEffect, useState } from "react";

const pad = (n) => String(n).padStart(2, "0");

export function useCountdown(ends, offset) {
  const [t, setT] = useState(() => Date.now() + offset);
  useEffect(() => { const id = setInterval(() => setT(Date.now() + offset), 1000); return () => clearInterval(id); }, [offset]);
  const left = Math.max(0, Math.floor((new Date(ends).getTime() - t) / 1000));
  return { left, d: Math.floor(left / 86400), h: Math.floor((left % 86400) / 3600), m: Math.floor((left % 3600) / 60), s: left % 60 };
}

const Cell = ({ v, label, accent, id }) => (
  <div className="flex flex-col items-center">
    <div data-testid={`countdown-${id}`} className="min-w-[3.4rem] sm:min-w-[4.5rem] px-2 py-2 sm:py-3 rounded-2xl bg-black/50 backdrop-blur border text-center font-display font-black text-2xl sm:text-4xl tabular-nums"
      style={{ borderColor: `${accent}55`, boxShadow: `0 0 24px ${accent}33 inset` }}>
      <span key={v} className="inline-block tick-in">{pad(v)}</span>
    </div>
    <span className="mt-1.5 text-[10px] uppercase tracking-[0.2em] text-white/60">{label}</span>
  </div>
);

export default function Countdown({ c, accent }) {
  const cells = [...(c.d > 0 ? [[c.d, "Days", "days"]] : []), [c.h, "Hrs", "hours"], [c.m, "Mins", "minutes"], [c.s, "Secs", "seconds"]];
  return (
    <div data-testid="festival-countdown" className="flex items-start gap-1.5 sm:gap-2">
      {cells.map(([v, l, id], i) => (
        <div key={id} className="flex items-start gap-1.5 sm:gap-2">
          {i > 0 && <span className="font-display font-black text-2xl sm:text-4xl pt-2 sm:pt-3 animate-pulse" style={{ color: accent }}>:</span>}
          <Cell v={v} label={l} accent={accent} id={id} />
        </div>
      ))}
    </div>
  );
}
